import { SerpProjectKeyword } from '@hydra/types/serp';

export function normalizeProjectKeywords (projectKeywords: SerpProjectKeyword[]) {
  if (projectKeywords.length > 0) {
    return projectKeywords.reduce(
      (normalizedProjectKeywords: { [key: string]: SerpProjectKeyword }, projectKeyword) => {
        normalizedProjectKeywords[projectKeyword.kwId] = projectKeyword;
        return normalizedProjectKeywords;
      },
      {}
    );
  }

  return {};
}

export function getProjectTagNames (project: { projectTags: { name: string }[] }) {
  if (!project || !project.projectTags) {
    return [];
  }

  return project.projectTags.map(({ name }) => name);
}

interface Keyword {
  keyword: string
  country?: string
  language?: string
  locName?: string
  locType?: string
}

export function isKeywordIncluded (keywordList: Keyword[], kw: Keyword) {
  return keywordList.find(({ keyword, country, language, locName, locType }) => {
    return keyword === kw.keyword && country === kw.country &&
      (language === kw.language || (language === 'default' && kw.language === '')) &&
      locName === kw.locName && locType === kw.locType;
  });
}
